// extracted by mini-css-extract-plugin
module.exports = {"box":"_video-styles-module--box--2F2n-","videocontainer":"_video-styles-module--videocontainer--3bb_o","paused":"_video-styles-module--paused--gxcg7"};